export default __webpack_public_path__ + "static/media/presentation.8447e549.pptx";